export const formatPhoneNumber = (phoneNumberString) => {
  if (!phoneNumberString || typeof phoneNumberString !== 'string') {
    return phoneNumberString;
  }

  const cleaned = phoneNumberString.replace(/\D/g, '');
  
  const match = cleaned.match(/^(?:1|)?(\d{10})$/);
  
  if (match) {
    const tenDigitNumber = match[1];
    return `(${tenDigitNumber.substring(0, 3)}) ${tenDigitNumber.substring(3, 6)}-${tenDigitNumber.substring(6, 10)}`;
  }
  
  return phoneNumberString;
}; 